import { render, staticRenderFns } from "./about-our-safety-center.vue?vue&type=template&id=2ee79e9e&scoped=true"
import script from "./about-our-safety-center.vue?vue&type=script&lang=js"
export * from "./about-our-safety-center.vue?vue&type=script&lang=js"
import style0 from "./about-our-safety-center.vue?vue&type=style&index=0&id=2ee79e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee79e9e",
  null
  
)

export default component.exports